import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import Routers from './routes';
import { useTranslation } from 'react-i18next'

import en_US from 'zarm/lib/config-provider/locale/en_US';
import zhCN from 'zarm/lib/config-provider/locale/zh_CN';
import { ConfigProvider } from 'zarm';
// import enUS from 'antd-mobile/es/locales/en-US'
// import { ConfigProvider } from "antd-mobile";
import VConsole from 'vconsole';
import 'zarm/dist/zarm.css';

const App: React.FC = () => {
  const { t, i18n } = useTranslation()
  // let vConsole = new VConsole();

  let language =en_US
  if(localStorage.getItem('lang')=='zh'){
    language =zhCN
  }else{
    language =en_US
  }

  return (
    <ConfigProvider  locale={language}  theme="dark" >
      <Router>
        <Routers />
      </Router>
    </ConfigProvider>
  );
};





export default App;
